import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  preference: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const PreferenceSlice = createSlice({
  name: "preference",
  initialState: INITIAL_STATE,
  reducers: {
    fetchPreferenceData: (state) => {
      state.preference.isLoading = true;
    },
    fetchPreferenceSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      preference: {
        ...state.preference,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchPreferenceFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      preference: {
        ...state.preference,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearPrefrences: (state) => ({
      ...state,
      preference: {
        ...state.preference,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const {
  fetchPreferenceData,
  fetchPreferenceFailure,
  fetchPreferenceSuccess,
  clearPrefrences,
} = PreferenceSlice.actions;
export const PreferenceReducer = PreferenceSlice.reducer;
